import { clickListener } from "utils/toggle-mysnow/toggle-mysnow"
import "./forecast-user-control.scss"

export default function setListeners() {
  const mysnowButtons = [...document.querySelectorAll("[data-mysnow-toggle]")]

  mysnowButtons.forEach((button) => {
    button.addEventListener("click", clickListener)
  })
}
